var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b-cls-1 {\n        fill: #14163d;\n      }\n\n      .b-cls-1, .b-cls-2 {\n        stroke-width: 0px;\n      }\n\n      .b-cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Briefing_icon",
    "data-name": "Briefing icon"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b-cls-1",
    cx: 130,
    cy: 130,
    r: 130
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b-cls-2",
    d: "m192.68,192.68h-125.36c-12.44,0-22.56-10.12-22.56-22.56v-80.23c0-12.44,10.12-22.56,22.56-22.56h125.36c12.44,0,22.56,10.12,22.56,22.56v80.23c0,12.44-10.12,22.56-22.56,22.56Zm-125.36-120.34c-9.68,0-17.55,7.87-17.55,17.55v80.23c0,9.68,7.87,17.55,17.55,17.55h125.36c9.68,0,17.55-7.87,17.55-17.55v-80.23c0-9.68-7.87-17.55-17.55-17.55h-125.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-cls-2",
    d: "m185.24,100.11h-110.48c-2.21,0-4-1.79-4-4s1.79-4,4-4h110.48c2.21,0,4,1.79,4,4s-1.79,4-4,4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b-cls-2",
    d: "m190.02,125.71h-91.44c-1.38,0-2.51-1.12-2.51-2.51s1.12-2.51,2.51-2.51h91.44c1.38,0,2.51,1.12,2.51,2.51s-1.12,2.51-2.51,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-cls-2",
    d: "m190.02,144.31h-91.44c-1.38,0-2.51-1.12-2.51-2.51s1.12-2.51,2.51-2.51h91.44c1.38,0,2.51,1.12,2.51,2.51s-1.12,2.51-2.51,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-cls-2",
    d: "m190.02,162.92h-91.44c-1.38,0-2.51-1.12-2.51-2.51s1.12-2.51,2.51-2.51h91.44c1.38,0,2.51,1.12,2.51,2.51s-1.12,2.51-2.51,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-cls-2",
    d: "m74.14,131.83c-.64,0-1.28-.24-1.77-.73l-5.38-5.38c-.98-.98-.98-2.56,0-3.54.98-.98,2.56-.98,3.54,0l3.61,3.61,10.49-10.49c.98-.98,2.56-.98,3.54,0,.98.98.98,2.56,0,3.54l-12.26,12.26c-.49.49-1.13.73-1.77.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-cls-2",
    d: "m74.14,150.43c-.64,0-1.28-.24-1.77-.73l-5.38-5.38c-.98-.98-.98-2.56,0-3.54.98-.98,2.56-.98,3.54,0l3.61,3.61,10.49-10.49c.98-.98,2.56-.98,3.54,0,.98.98.98,2.56,0,3.54l-12.26,12.26c-.49.49-1.13.73-1.77.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-cls-2",
    d: "m74.14,169.04c-.64,0-1.28-.24-1.77-.73l-5.38-5.38c-.98-.98-.98-2.56,0-3.54.98-.98,2.56-.98,3.54,0l3.61,3.61,10.49-10.49c.98-.98,2.56-.98,3.54,0,.98.98.98,2.56,0,3.54l-12.26,12.26c-.49.49-1.13.73-1.77.73Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefing);
export default __webpack_public_path__ + "static/media/Briefing.a5822e5c4860f87ca00c5cf8735b9017.svg";
export { ForwardRef as ReactComponent };